import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalRemoveSpaceLink: ExperimentalMutations['experimentalRemoveSpaceLink'] = (
	_,
	{ id, spaceKey },
	{ network: { cfetch } },
) =>
	cfetch(`/wiki/rest/ia/1.0/link/${id}/hide`, {
		method: 'POST',
		body: JSON.stringify({
			spaceKey,
		}),
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).then(() => true);
